export default "__VITE_ASSET__9ZzxE06M__"